import { Link } from 'react-router-dom';
import './LandingPage.css';
import { SCREENS } from '../lib/screenRegistry';
import { ROUTES } from '../lib/classroomRoutes';
import { LANDING_OPENING_PARAGRAPH } from '../lib/landingCopy';

export default function LandingPage() {
  return (
    <div className="landing-page" data-screen-id={SCREENS.MPL01}>
      <div className="landing-logo-wrap">
        <img
          src={encodeURI('/Assets/logo/mentology- logo.png')}
          alt="Mentology"
          className="landing-logo brand-logo"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      </div>
      <div className="landing-content">
        <p className="landing-intro">{LANDING_OPENING_PARAGRAPH}</p>
        <div className="landing-button-box">
          <div className="button-control-group">
            <Link to={ROUTES.REGISTRATION_PATHWAY} className="btn-landing-primary">
              [NEW REGISTRATION]
            </Link>
            <Link to={ROUTES.CLASSROOM_PORTAL} className="btn-landing-primary">
              [CLASSROOM PORTAL]
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
